import { AbstractPmsApiService } from './abstract.service'
import { Role } from "../models";

/**
 * @class MabeetRolePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Role>}
 */
export class MabeetRolePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/mabeet-role(/:id)'
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Role}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Role(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<Role>>}
     */
    get(params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Role} role
     * @returns {Promise.<Role>}
     */
    create(role) {

        const url = this.url();

        return this.http
            .post(url, role.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Role} role
     * @returns {Promise.<Role>}
     */
    update(role) {

        const url = this.url({
            id: role.id
        });

        return this.http
            .put(url, role.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Role} role
     * @returns {Promise.<boolean>}
     */
    delete(role) {

        const url = this.url({
            id: role.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Integer} roleId
     * @param {Object} params
     */
    show(roleId, params = {}) {

        const url = this.url({
            id: roleId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/mabeet-role.service.js